import { render, staticRenderFns } from "./PropVideoViewsTotal.vue?vue&type=template&id=78f0985c&"
import script from "./PropVideoViewsTotal.vue?vue&type=script&lang=js&"
export * from "./PropVideoViewsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports